module.exports = __webpack_public_path__ + "img/BackgroundImage_01_Trimmed.2bd8ac6d.png";